import axios from "axios"
import $ from "jquery"
import { urlHelper } from "@/components/mixins/urlHelper"
import store from "@/store"

axios.interceptors.request.use(config => {
  const headerState = store.getters.headerState;
  if (headerState && headerState.UserId) {
    config.headers['UserId'] = headerState.UserId;
    config.headers['AccountId'] = headerState.AccountId;
    config.headers['MCFCostCenterId'] = headerState.MCFCostCenterId;
    config.headers['ClientId'] = headerState.ClientId;
  }

  return config;
});

export const UserService = Object.freeze({
  GetUser: function () {

    var reqUrl = window.appGlobals.API_URL + "appian/GetUser?siteKey=" + window.appGlobals.SITE_KEY;
    return axios.get(reqUrl);
  },
GetUserAndAvailableAccounts: async function (siteKey) {
    let reqUrl = window.appGlobals.API_URL + "appian/GetUserAndDealerAuth?siteKey=" + siteKey
    const response = await axios.post(reqUrl)

    store.commit('SET_HEADER_STATE', {
      UserId: response.data.User.UserId,
      AccountId: response.data.User.PrimaryAccountId,
      MCFCostCenterId: store.getters.McfCostCenterId,
      ClientId: 1
    })
    return response
  },

  GetAvailableAccountsAndBrandAuth: function (dealerCode, userId, userDealerRange) {
    var dealerRange = { Range: userDealerRange }
    let reqUrl = window.appGlobals.API_URL + "appian/GetDealerCodesAndBrandAuth?dealerCode=" + dealerCode + "&userId=" + userId
    return axios.post(reqUrl, dealerRange)
  },
  AccountDetails: function () {
    return axios.get(window.appGlobals.API_URL + "AccountDetails")
  },
  UpdateActiveDealerCode: function (dealerCode, dealerRange, userId) {
    var updateDealerCodeDto = { 
      DealerCode: dealerCode,
      DealerRange: dealerRange,
      UserId: userId,
      SiteKey: window.appGlobals.SITE_KEY
    }
    let reqUrl = window.appGlobals.API_URL + "appian/UpdateActiveDealerCode"
    return axios.post(reqUrl, updateDealerCodeDto)
  },
  GetLogoutUrl: function () {
    var reqUrl = window.appGlobals.API_URL + "appian/GetLogoutUrl"
    return axios.get(reqUrl)
  },
  ResetDn6Session: function (sessionVarString) {
    return axios.get("/WebServices/GlobalLoginWS.asmx/ResetSession?SessionVariables=" + sessionVarString)
  },
  GetAudienceAndExclusions (accountId, userId) {
    let reqUrl = window.appGlobals.API_URL + "Exclusions/GetAudiencesAndExclusionsForUser?accountId=" + accountId + "&userId=" + userId
    return axios.get(reqUrl)
  },
  GetUserTour: function (userId, clientId, tourIds = [], tourNames = []) {
    var userTourRecordDto = {
      UserId: userId,
      ClientId: clientId,
      TourIds: tourIds,
      TourNames: tourNames
    }
    let reqUrl = window.appGlobals.API_URL + "UserSettings/GetUserTour"
    return axios.post(reqUrl, userTourRecordDto)
  },
  GetTour: function (tourName, clientId, isActive) {
    const reqUrl =
      window.appGlobals.API_URL +
      "UserSettings/GetTour?tourName=" + encodeURIComponent(tourName) +
      "&clientId=" + clientId +
      "&isActive=" + isActive
    return axios.get(reqUrl)
  },
  UpsertUserTours: function (userId, tourId, startDate, endDate) {
    var userTourDto = {
      UserId: userId,
      TourId: tourId,
      StartDate: startDate,
      EndDate: endDate
    }
    let reqUrl = window.appGlobals.API_URL + "UserSettings/UpsertUserTours"
    return axios.post(reqUrl, [userTourDto])
  },
  GetMCFEDealerSupportSites: function (dealerCode, userId, userDealerRange) {
    var dealerRange = { Range: userDealerRange }
    let reqUrl = window.appGlobals.API_URL + "appian/GetMCFEDealerSupportSites?dealerCode=" + dealerCode + "&userId=" + userId
    return axios.post(reqUrl, dealerRange)
  },
})
